import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMap from 'highcharts/modules/map';
import * as Highcharts from 'highcharts';
import { LoadingContainer, NoData, SectionWrapper } from './ChartList.styles';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { useAcrossUsaContext } from 'contexts/SupplierDiversity/AcrossUsaProvider';
import Header from 'SupplierDiversity/components/Header/Header';
import Filter from 'SupplierDiversity/components/Filter/Filter';
import CategoryMultiSelect from 'Settings/FirstUsageSettings/CategoryMultiSelect';
import ApplyButton from 'SupplierDiversity/components/ActionButton/ActionButton';
HighchartsMap(Highcharts);

const chartTitle = 'USA Heatmap';

const UsaHeatmap = () => {
	const {
		isLoading,
		data,
		options,
		certificationFilter,
		certificationFilterHandler,
		getData,
	} = useAcrossUsaContext();
	return (
		<SectionWrapper>
			<Header chartTitle={chartTitle}>
				{!isLoading && (
					<Filter>
						<div>
							<CategoryMultiSelect
								name="Certifications"
								onChange={certificationFilterHandler}
								options={certificationFilter.options}
								selected={certificationFilter.selected}
								label="Certifications"
							/>
						</div>
						<ApplyButton label="Apply" onClick={getData} />
					</Filter>
				)}
			</Header>
			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact
							highcharts={Highcharts}
							options={options}
							constructorType="mapChart"
						/>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default UsaHeatmap;
